import { render, staticRenderFns } from "./selectPolicyGradient.vue?vue&type=template&id=54b5f80e&scoped=true"
import script from "./selectPolicyGradient.vue?vue&type=script&lang=js"
export * from "./selectPolicyGradient.vue?vue&type=script&lang=js"
import style0 from "./selectPolicyGradient.vue?vue&type=style&index=0&id=54b5f80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5f80e",
  null
  
)

export default component.exports